import { Autocomplete, Stack, TextField, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';

export interface CustomerAssortmentOption {
  assortmentId: number;
  name: string;
}

interface Props {
  customerAssortments: CustomerAssortmentOption[];
  selectedAssortmentId: number | null;
  selectAssortment: (assortmentId: number | null) => void;
}

export function CustomerAssortmentSelect({
  customerAssortments,
  selectedAssortmentId,
  selectAssortment,
}: Props) {
  const t = useAppTFunction();

  return (
    <Stack gap={0.5}>
      <Typography
        component="label"
        htmlFor="customerAssortmentSelect"
        variant="body2"
        color="text.secondary"
      >
        {t('app.customerAssortments.selectLabel')}
      </Typography>
      <Autocomplete
        id="customerAssortmentSelect"
        options={customerAssortments}
        size="small"
        isOptionEqualToValue={(option, value) => option.assortmentId === value.assortmentId}
        value={
          customerAssortments.find(({ assortmentId }) => assortmentId === selectedAssortmentId) ??
          null
        }
        onChange={(_, newValue) => selectAssortment(newValue?.assortmentId ?? null)}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField {...params} placeholder={t('app.customerAssortments.selectPlaceholder')} />
        )}
      />
    </Stack>
  );
}
